<template>
  <div>
    <Header :title="$t('loaninfo.title') + '#' + data.code" />
    <div
      class="full-page-box"
      style="background-color: rgb(248 249 250); min-height: calc(100vh)"
    >
      <div class="loan-money">
        <p>{{ $t("loaninfo.msg") }}</p>
        <p>{{ formatNumberWithCommas(data.price) }} {{ $t("common.unit") }}</p>
      </div>
      <div style="width: 96%; margin: 20px auto">
        <van-row style="width: 80%; margin: 0 auto 10px">
          <van-col :span="2">
            <div :class="active >= 1 ? 'iconpass':'icon'">1</div>
          </van-col>
          <van-col :span="9">
            <van-divider :style="{ borderColor: active >= 2 ? 'rgb(4 109 181)':'#adb7bb' }" />
          </van-col>
          <van-col :span="2">
            <div :class="active >= 2 ? 'iconpass':'icon'">2</div>
          </van-col>
          <van-col :span="9">
            <van-divider :style="{ borderColor: active >= 3 ? 'rgb(4 109 181)':'#adb7bb' }" />
          </van-col>
          <van-col :span="2">
            <div :class="active >= 3 ? 'iconpass':'icon'">3</div>
          </van-col>
        </van-row>
        <van-row style="text-align: center">
          <van-col :span="6">
            <div :class="active >= 1 ? 'txtcolorpass':'txtcolor'">{{ $t("loaninfo.state1") }}</div>
          </van-col>
          <van-col :span="2"></van-col>
          <van-col :span="8">
            <div :class="active >= 2 ? 'txtcolorpass':'txtcolor'">{{ $t("loaninfo.state2") }}</div>
          </van-col>
          <van-col :span="2"></van-col>
          <van-col :span="6">
            <div :class="active >= 3 ? 'txtcolorpass':'txtcolor'">{{ $t("loaninfo.state3") }}</div>
          </van-col>
        </van-row>
      </div>
      <div class="loan-box-tile">
        <p>{{ $t('loaninfo.notify') }}</p>
        <p>{{ $t('loaninfo.notifymsg1') }}</p>
        <p>{{ $t('loaninfo.thanks') }}</p>
      </div>
      <div class="loan-box-tile">
        <van-row>
            <van-col :span="8">{{ $t("loaninfo.code") }}</van-col>
            <van-col :span="16" class="text-right"
              >{{ data.oid }}</van-col
            >
          </van-row>
          <van-divider
            :dashed="true"
            :style="{ borderColor: 'rgb(254 127 45)' }"
          />
        <van-row>
            <van-col :span="12">{{ $t("loaninfo.money") }}</van-col>
            <van-col :span="12" class="text-right"
              >{{  formatNumberWithCommas(data.price) }} {{ $t("common.unit") }}</van-col
            >
          </van-row>
          <van-divider
            :dashed="true"
            :style="{ borderColor: 'rgb(254 127 45)' }"
          />
          <van-row>
            <van-col :span="12">{{ $t("loaninfo.cycle") }}</van-col>
            <van-col :span="12" class="text-right"
              >{{ data.term }} {{ $t("common.month") }}</van-col
            >
          </van-row>
          <van-divider
            :dashed="true"
            :style="{ borderColor: 'rgb(254 127 45)' }"
          />
          <van-row>
            <van-col :span="12">
              <p>{{ $t("loaninfo.everyissue") }}</p>
              ({{ $t("loaninfo.everyissuedesc") }})
            </van-col>
            <van-col :span="12" class="text-right" style="font-weight: 700"
              >{{  formatNumberWithCommas(data.monthlyPayment)  }} {{ $t("common.unit") }}</van-col
            >
          </van-row>
          <van-divider
            :dashed="true"
            :style="{ borderColor: 'rgb(254 127 45)' }"
          />
          <van-row>
            <van-col :span="12">{{ $t("loaninfo.bank") }}</van-col>
            <van-col :span="12" class="text-right">{{ data.bank }}</van-col>
          </van-row>
          <van-divider
            :dashed="true"
            :style="{ borderColor: 'rgb(254 127 45)' }"
          />
          <van-row>
            <van-col :span="24" class="topay">
                <p>{{ $t('loaninfo.msg1') }}</p>
                <p>{{ $t('loaninfo.msg2', {day: getMonth(data.timeStart)}) }}</p>
                <p><span @click="tomybag">{{ $t('loaninfo.btn') }}<van-icon name="arrow" /></span></p>
            </van-col>
          </van-row>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import Header from "@/components/header/index.vue";
import { formatNumberWithCommas } from "@/utils/validate";
export default {
  name: "LoanInfo",
  components: { Header },
  data() {
    return {
      oid: null,
      active: 1,
      data:{}
    };
  },
  created(){
    if(!localStorage.getItem('token')){
      this.$router.push({ name: 'login' });
    }
  },
  mounted() {
    this.oid = this.$route.query.oid;
    if (this.oid) {
      this.getdata()
    } else {
      this.$router.push({ name: "loan" });
    }
  },
  methods:{
    getMonth(val){
      const d = new Date(val)
      return d.getDate()
    },
    formatNumberWithCommas(val){
      return formatNumberWithCommas(val)
    },
    tomybag(){
      // this.$router.push({ name: "bill" });
      Toast('Không có doanh nghiệp nào cần sự chú ý của bạn vào lúc này')
    },
    getdata() {
      this.$http({
        method: "get",
        data:{id:this.oid},
        url: "getloan",
      }).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.data = res.data[0]
            this.active = this.data.status
          }
        } else {
          Toast(res.msg);
        }
      });
    },
  }
};
</script>
<style scoped>
.loan-money {
  width: 96%;
  margin: 20px auto;
  line-height: 1.8;
  text-align: center;
}
.loan-money p {
  font-size: 20px;
  font-weight: 600;
}
.icon {
  border: 1px solid #adb7bb;
  background-color: #adb7bb;
  width: 35px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  border-radius: 35px;
  z-index: 99;
}
.iconpass {
  border: 1px solid rgb(4 109 181);
  background-color: rgb(4 109 181);
  width: 35px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  border-radius: 35px;
  z-index: 99;
}
.txtcolor{
    color: #adb7bb;
}
.txtcolorpass{
    color: rgb(4 109 181);
}
.loan-box-tile {
  width: 96%;
  margin: 20px auto;
  border-radius: 8px;
  background-color: #fff;
  padding: 15px;
  line-height: 1.6;
}
.loan-box-tile > p:nth-child(1) {
    color: rgb(4 109 181);
    font-size: 18px;
}
.text-right {
  text-align: right;
}
.topay {
    line-height: 2;
}
.topay > p:nth-child(2n - 1) {
    color: rgb(4 109 181);
}
</style>
